import React, { lazy } from 'react';
import IconFoom from '@/assets/images/menu/icon-foom.react.svg?react';
import { AuthNodes } from '@/config/app/auth';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const foomRoutes = (): IRouteConfig[] => [
  {
    path: '/exception/foom',
    name: 'FOOM',
    icon: <MenuIcon icon={IconFoom} />,
    sort: 97,
    platforms: [
      CapitalPlatform.IOS,
      CapitalPlatform.VisionOS,
      CapitalPlatform.AppleTV,
    ],
    authName: AuthNodes.Foom,
    disabledByFree: true,
    routes: [
      {
        path: '/exception/foom/analytics',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/foom/analytics')),
      },
      {
        path: '/exception/foom/issues/list',
        name: '问题列表',
        component: lazy(() => import('@/presentation/pages/foom/case/list')),
      },
      {
        path: '/exception/foom/issues/detail',
        name: '问题详情',
        component: lazy(() => import('@/presentation/pages/foom/case/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/exception/foom/malloc/list',
        name: '内存分配列表',
        component: lazy(() => import('@/presentation/pages/foom/malloc/list')),
        platforms: [
          CapitalPlatform.IOS,
          CapitalPlatform.VisionOS,
          CapitalPlatform.AppleTV,
        ],
      },
      {
        path: '/exception/foom/malloc/vmmap-detail',
        name: 'VMMAP分析',
        component: lazy(() => import('@/presentation/pages/memory/vmmap-detail/list')),
      },
      {
        path: '/exception/foom/malloc/detail',
        name: '分配详情',
        component: lazy(() => import('@/presentation/pages/foom/malloc/detail')),
        hideInMenu: true,
        whitelisted: true,
        platforms: [
          CapitalPlatform.IOS,
          CapitalPlatform.VisionOS,
          CapitalPlatform.AppleTV,
        ],
      },
    ],
  },
];

export default foomRoutes;
